import React from 'react';
import { useLocation } from 'react-router-dom';
import { useHelp } from '../../context/HelpContext';
import { useLanguage } from '../../context/LanguageContext';
import { useExam } from '../../context/ExamContext';
import { useQuiz } from '../../context/QuizContext';
import { HELP_DEFINITIONS } from '../../data/helpDefinitions';

function useCurrentHelpPageId() {
    const { pathname } = useLocation();

    if (pathname.match(/^\/dashboard\/account\/orders/)) return 'order-history';
    if (pathname.match(/^\/dashboard\/account\/?$/)) return 'account';
    if (pathname.match(/^\/dashboard\/training/)) return 'training-hub';
    if (pathname.match(/^\/courses/)) return 'course-catalog';
    // Level overview: /dashboard/:levelId (but not /dashboard/account, /dashboard/training, etc.)
    if (pathname.match(/^\/dashboard\/[a-z0-9]+$/i) && !pathname.match(/^\/dashboard\/(account|training|stats|exam|review)/)) {
        return 'level-overview';
    }
    return null;
}

const HelpTrigger = () => {
    const { helpPrefs, startTour, isTourActive, activeHelpPage } = useHelp();
    const { language } = useLanguage();
    const { examId } = useExam();
    const { quizId } = useQuiz();
    const urlPageId = useCurrentHelpPageId();
    // Components can override the URL-based mapping (e.g., stats tab within level-overview)
    // During exam/quiz sessions, show the session-specific guide
    const sessionPageId = examId ? 'exam-session' : quizId ? 'quiz-session' : null;
    const pageId = sessionPageId || activeHelpPage || urlPageId;

    // Don't render if globally disabled, button hidden, no help for this page, or tour already active
    if (!helpPrefs.globalEnabled || !helpPrefs.showTriggerButton || !pageId || isTourActive) return null;
    if (!HELP_DEFINITIONS[pageId]) return null;

    return (
        <button
            onClick={() => startTour(pageId)}
            className="
                fixed bottom-6 right-6 z-[400]
                flex items-center gap-2 px-4 py-2.5
                bg-white/90 dark:bg-gray-900/90 backdrop-blur-xl
                border border-gray-200 dark:border-white/10
                rounded-full shadow-lg shadow-black/5 dark:shadow-black/20
                hover:shadow-xl hover:scale-105 active:scale-95
                transition-all duration-200
                group
                animate-help-trigger-in
            "
            title={language === 'fr' ? 'Guide contextuel' : 'Contextual guide'}
        >
            {/* Question mark icon */}
            <div className="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center text-white text-xs font-black group-hover:bg-blue-700 transition">
                ?
            </div>
            <span className="text-xs font-bold text-gray-700 dark:text-gray-300 hidden sm:block">
                {language === 'fr' ? 'Guide' : 'Guide'}
            </span>
        </button>
    );
};

export default HelpTrigger;
